import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from "../../api/api";

// Async thunk to fetch Instagram reels
export const fetchInstagramReels = createAsyncThunk(
    'reels/fetchInstagramReels',
    async (payload, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.post('/getReels', payload, { withCredentials: true });
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: "Failed to fetch reels" });
        }
    }
);
export const fetchReelsById = createAsyncThunk(
    'reels/fetchReelsById',
    async (payload, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.post('/getReelsById', payload, { withCredentials: true });
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(error.response?.data || { error: "Failed to fetch reels" });
        }
    }
);


const instagramReelsSlice = createSlice({
    name: 'instagramReels',
    initialState: {
        reels: [],
        currentPage: 1,
        successMessage: '',
        errorMessage: '',
        loader: false,
        totalReels: 0
    },
    reducers: {
        messageClear: (state) => {
            state.errorMessage = "";
            state.successMessage = "";
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchInstagramReels.pending, (state) => {
                state.loader = true;
            })
            .addCase(fetchInstagramReels.rejected, (state, { payload }) => {
                state.loader = false;
                state.errorMessage = payload.error;
            })
            .addCase(fetchInstagramReels.fulfilled, (state, { payload }) => {
                state.loader = false;
                state.reels = payload.reels || [];
                state.totalReels = payload.totalReels
                state.totalReels = payload.currentPage
                state.successMessage = "Reels fetched successfully";
            })
            .addCase(fetchReelsById.pending, (state) => {
                state.loader = true;
            })
            .addCase(fetchReelsById.rejected, (state, { payload }) => {
                state.loader = false;
                state.errorMessage = payload.error;
            })
            .addCase(fetchReelsById.fulfilled, (state, { payload }) => {
                state.loader = false;
                state.reels = payload.reels || [];
                state.totalReels = payload.totalReels
                state.totalReels = payload.currentPage
                state.successMessage = "Reels fetched successfully";
            });
    }
});

export default instagramReelsSlice.reducer;
export const { messageClear } = instagramReelsSlice.actions;
